import React, { Fragment, useEffect, useState } from 'react'

import { Helmet } from 'react-helmet'

import Contact10 from '../components/contact10'
import CTA26 from '../components/cta26'
import Features24 from '../components/features24'
// import Features25 from '../components/features25'
import Footer4 from '../components/footer4'
import Hero17 from '../components/hero17'
import Navbar8 from '../components/navbar8'
import Pricing14 from '../components/pricing14'
import Steps2 from '../components/steps2'
// import Testimonial17 from '../components/testimonial17'
import './home.css'
import { Link } from 'react-router-dom'
import BlurText from '../components/BlurText'
import AnimatedContent from '../components/AnimatedContent'
import HeroMap from '../components/HeroMap'




const Home = (props) => {

  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const role = sessionStorage.getItem('userRole');
    setUserRole(role);
  }, []);

  const handleAnimationComplete = () => {
    console.log('Animation completed!');
  };

  return (
    <div className="home-container">
      <Helmet>
        <title>KaamSaathi</title>
        <meta property="og:title" content="KaamSaathi" />
      </Helmet>
      <Navbar8
        link1={
          <Fragment>
            <span className="home-text100">Home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text101">About Us</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text102">Contact</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="home-text103">More</span>
          </Fragment>
        }
        page1={
          <Fragment>
            <span className="home-text104">Home</span>
          </Fragment>
        }
        page2={
          <Fragment>
            <span className="home-text105">About Us</span>
          </Fragment>
        }
        page3={
          <Fragment>
            <span className="home-text106">Contact</span>
          </Fragment>
        }
        page4={
          <Fragment>
            <span className="home-text107">More</span>
          </Fragment>
        }
        action1={
          <Link to="/attendance" className="nav-link">
            <span className="home-text109">Attendance</span>
          </Link>
        }
        page1Description={
          <Fragment>
            <span className="home-text110">
              Welcome to our Platform homepage.
            </span>
          </Fragment>
        }
        page2Description={
          <Fragment>
            <span className="home-text111">
              Fill out the form to post a job opening.
            </span>
          </Fragment>
        }
        page3Description={
          <Fragment>
            <span className="home-text112">
              Manage your job postings and applications.
            </span>
          </Fragment>
        }
        page4Description={
          <Fragment>
            <span className="home-text113">
              Sign in to access your account.
            </span>
          </Fragment>
        }
      ></Navbar8>
      {userRole === "Contractor" && <HeroMap />}
      {userRole === "Labour" && 
        <Hero17
        action1={
          userRole === "Labour" ? (
            <Link to="/browse-jobs" className="nav-link">
            <span className="home-text114">Browse Jobs</span>
          </Link>
          ) : (
            <Link to="/" className="nav-link">
              <span className="home-text114">Switch Role</span>
            </Link>
          )
        }
        action2={
          userRole === "Contractor" ? (
            <Link to="/post-job" className="nav-link">
            <span className="home-text114">Post a Job</span>
          </Link>
          ) : (
            <Link to="/" className="nav-link">
            <span className="home-text114">Switch Role</span>
          </Link>
          )
        }
        content1={
          <AnimatedContent
            distance={150}
            direction="vertical"
            reverse={false}
            config={{ tension: 80, friction: 25 }}
            initialOpacity={0}
            animateOpacity={true}
            scale={1.1}
            threshold={0.4}
          >
            <div>Find your dream job with us. Explore thousands of job
            opportunities from top companies.</div>
          </AnimatedContent>
        }
        heading1={
          <BlurText
            text="Welcome to our Platform!"
            delay={100}
            animateBy="words"
            direction="top"
            onAnimationComplete={handleAnimationComplete}
            className="text-2xl mb-8"
          />
        }
      ></Hero17>
      }
      {/* <Features24
        feature1Title={
          <Fragment>
            <span className="home-text118">Homepage</span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="home-text119">Job Posting Form</span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="home-text120">Dashboard</span>
          </Fragment>
        }
        feature1Description={
          <Fragment>
            <span className="home-text121">
              Engaging landing page with featured jobs and search functionality
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text122">
              Easy-to-use form for employers to post job listings
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text123">
              Personalized dashboard for job seekers and employers to manage
              applications and listings
            </span>
          </Fragment>
        }
      ></Features24> */}
      {/* <Features25
        feature1Title={
          <Fragment>
            <span className="home-text127">Homepage</span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="home-text128">Job Posting Form</span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="home-text129">Dashboard</span>
          </Fragment>
        }
        feature1Description={
          <Fragment>
            <span className="home-text130">
              Engaging homepage design to attract users
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text131">
              User-friendly form for employers to post job listings
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text132">
              Personalized dashboard for users to manage job applications and
              settings
            </span>
          </Fragment>
        }
      ></Features25> */}
      {userRole === "Labour" && <Steps2
        step1Title={
          <Fragment>
            <span className="home-text186">Sign Up</span>
          </Fragment>
        }
        step2Title={
          <Fragment>
            <span className="home-text187">Browse Jobs</span>
          </Fragment>
        }
        // step3Title={
        //   <Fragment>
        //     <span className="home-text188">Post a Job</span>
        //   </Fragment>
        // }
        step4Title={
          <Fragment>
            <span className="home-text189">Dashboard</span>
          </Fragment>
        }
        step1Description={
          <Fragment>
            <span className="home-text190">
              Create an account on our job portal to access all features and
              functionalities.
            </span>
          </Fragment>
        }
        step2Description={
          <Fragment>
            <span className="home-text191">
              Browse through a wide range of job listings from various locations.
            </span>
          </Fragment>
        }
        step3Description={
          <Fragment>
            <span className="home-text192">
              Manage jobs, applications, and track the payment
              process efficiently.
            </span>
          </Fragment>
        }
        // step4Description={
        //   <Fragment>
        //     <span className="home-text193">
        //       Manage job postings, applications, and track the recruitment
        //       process efficiently.
        //     </span>
        //   </Fragment>
        // }
      ></Steps2>}
      {/* <Testimonial17
        review1={
          <Fragment>
            <span className="home-text194">
              Great platform for job seekers and employers alike. Easy to use
              and efficient.
            </span>
          </Fragment>
        }
        review2={
          <Fragment>
            <span className="home-text195">
              Our company has found some excellent candidates through this
              portal. Highly recommended.
            </span>
          </Fragment>
        }
        review3={
          <Fragment>
            <span className="home-text196">
              Impressive features and user-friendly interface. Makes the hiring
              process smoother.
            </span>
          </Fragment>
        }
        review4={
          <Fragment>
            <span className="home-text197">
              I landed my dream job through this portal. Thank you for the
              opportunity!
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text198">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text199">Testimonials</span>
          </Fragment>
        }
        author1Name={
          <Fragment>
            <span className="home-text200">John Doe</span>
          </Fragment>
        }
        author2Name={
          <Fragment>
            <span className="home-text201">Jane Smith</span>
          </Fragment>
        }
        author3Name={
          <Fragment>
            <span className="home-text202">Michael Johnson</span>
          </Fragment>
        }
        author4Name={
          <Fragment>
            <span className="home-text203">Emily Brown</span>
          </Fragment>
        }
        author1Position={
          <Fragment>
            <span className="home-text204">Software Engineer</span>
          </Fragment>
        }
        author2Position={
          <Fragment>
            <span className="home-text205">HR Manager</span>
          </Fragment>
        }
        author3Position={
          <Fragment>
            <span className="home-text206">Recruitment Consultant</span>
          </Fragment>
        }
        author4Position={
          <Fragment>
            <span className="home-text207">Job Seeker</span>
          </Fragment>
        }
      ></Testimonial17> */}
      {/* <Contact10
        content1={
          <Fragment>
            <span className="home-text208">
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text209">Locations</span>
          </Fragment>
        }
        location1={
          <Fragment>
            <span className="home-text210">Mulund</span>
          </Fragment>
        }
        location2={
          <Fragment>
            <span className="home-text211">Ghatkopar</span>
          </Fragment>
        }
        location1Description={
          <Fragment>
            <span className="home-text212">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse varius enim in ero.
            </span>
          </Fragment>
        }
        location2Description={
          <Fragment>
            <span className="home-text213">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse varius enim in ero.
            </span>
          </Fragment>
        }
      ></Contact10> */}
      <Footer4
        link1={
          <Fragment>
            <span className="home-text214">Home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text215">About Us</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text216">Contact</span>
          </Fragment>
        }
        link4={
          <Link to='/subscriptions'>
            <span className="home-text217">Subscriptions</span>
          </Link>
        }
        termsLink={
          <Fragment>
            <span className="home-text219">Terms and Conditions</span>
          </Fragment>
        }
        cookiesLink={
          <Fragment>
            <span className="home-text220">Cookies Policy</span>
          </Fragment>
        }
        privacyLink={
          <Fragment>
            <span className="home-text221">Privacy Policy</span>
          </Fragment>
        }
      ></Footer4>
    </div>
  )
}

export default Home;
